import React from "react";
import { Modal } from "../../secondary";
import style from "./assessmentDetail.module.scss";
import { Button } from "../../primary";

const PdfImageConfirmationModal = ({ modalOpen, setModalOpen, navigateToPdf }) => {
  return (
    <Modal modalOpen={modalOpen} modalClose={() => setModalOpen(false)} modalSize={style.custom_modal_size_woundImage}>
      {
        <div className={style.modalparent}>
          <div className={`${style.modal_heading} pb-2`}>
            <div className={`${style.modal_header} pl-3 pt-3`}>
              <h3>PDF Download</h3>
            </div>
            <button type="button" className={`close ${style.close_icon} pr-3`} onClick={() => setModalOpen(false)}>
              &times;
            </button>
          </div>

          <div className={`${style.modal_footer}`}>
            <div className={"px-4 mt-5"}>
              <h2>
                Do you want to include <br /> wound images?
              </h2>
            </div>
            <div className={"d-flex justify-content-center px-3 pt-5 pb-2"}>
              <Button
                type="submit"
                value="Yes"
                classes={{ className: `btn btn-small ml-0 mr-5 ${style.btn_small} ${style.btn_custom}` }}
                id="save"
                onClick={() => navigateToPdf(true)}
              />

              <Button
                type="button"
                value="No"
                classes={{ className: `btn btn-small ${style.btn_small_cancel} ${style.btn_custom} ml-4` }}
                id="cancel"
                onClick={() => navigateToPdf()}
              />
            </div>
          </div>
        </div>
      }
    </Modal>
  );
};

export default PdfImageConfirmationModal;
